import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShippingMethods = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "m6.269 4.372 8.559 3.999",
		stroke: "var(--color-primary-300)",
		strokeWidth: 4.167,
		strokeMiterlimit: 10
	}), /* @__PURE__ */ _jsx("path", {
		d: "M10.825 1.81a1.761 1.761 0 0 0-1.62-.016L2.488 4.983a1.441 1.441 0 0 0-.822 1.301v7.227c0 .644.37 1.231.952 1.506l6.548 3.106V9.005l-5.59-2.732L9.95 3.284c.031-.017.069-.017.13.016l6.698 3.01-5.945 2.743.003 9.073 6.545-3.109c.583-.276.952-.862.952-1.506V6.284a1.44 1.44 0 0 0-.822-1.301l-6.686-3.174Z",
		fill: "var(--main-color)"
	})]
});
export { SvgShippingMethods as ReactComponent };
